import { render, staticRenderFns } from "./inDetail.vue?vue&type=template&id=00af2e8b&scoped=true"
import script from "./inDetail.vue?vue&type=script&lang=js"
export * from "./inDetail.vue?vue&type=script&lang=js"
import style0 from "./inDetail.vue?vue&type=style&index=0&id=00af2e8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af2e8b",
  null
  
)

export default component.exports